export default "__VITE_ASSET__BztVTugW__"